import DataPrmrj from "@/services/DataPrmrj";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";


@Module({ store, dynamic: true, name: "storePrmrj" })
class StorePrmrj extends VuexModule {
  riwayatPrmrj = []
  prmrj = []
  detailPrmrj = {}

  @Mutation SET_DETAIL_PRMRJ(detailPrmrj) {
    this.detailPrmrj = detailPrmrj;
  }

  @Mutation SET_RIWAYAT_PRMRJ(riwayatPrmrj = []) {
    this.riwayatPrmrj = riwayatPrmrj;
  }

  @Mutation SET_PRMRJ(prmrj = []) {
    this.prmrj = prmrj;
  }

  // @Action actAsesmenRisikoJatuh(param) {
  //   const dt = DataAsesmenRisikoJatuh.getDataAsesmenRisikoJatuh(param["unit_id"], param["reg"]);
  //   // appModule.setLoading(true);
  //   dt.then(dt => {
  //     // appModule.setLoading(false);
  //     const detail = dt.data
  //     this.SET_ASSESMEN_RISIKO_JATUH(detail)
  //   });
  // }

  @Action actPrmrjByRM(rm) {
    const dt = DataPrmrj.getDataPrmrj(rm);
    appModule.setLoading(true);
    dt.then(dt => {
      appModule.setLoading(false);
      const data = dt.data
      this.SET_RIWAYAT_PRMRJ(data)
    });
  }

  @Action actPrmrjByReg(param) {
    console.log('store=',param)
    const dt = DataPrmrj.getDataPrmrjByReg(param['reg'], param['id']);
    // appModule.setLoading(true);
    dt.then(dt => {
      // appModule.setLoading(false);
      const data = dt.data[0]
      this.SET_DETAIL_PRMRJ(data)
    });
    
  }
}

export const storePrmrj = getModule(StorePrmrj);
